export default __webpack_public_path__ + "static/media/logo.ea760e6d.svg";